import GiftIcon from '../../../../../ui/svg/shopping-cart/gift';
import { useAppSelector } from '../../data/store';
import { getNumberOfFreePlugins } from '../../domain/free-plugin-provider';

/**
 * if text should be in plural -> add s suffix
 */
export const plural = (text: string, count: number) => {
    return `${text}${ count > 1 ? 's' : '' }`;
};

const FreePluginBox = () => {
    const cartData = useAppSelector(store => store.root.cartData);
    const numberOfFreePlugins = getNumberOfFreePlugins(cartData);

    return (
        <div className="text-gray-700 border border-green rounded bg-green-100 px-3 py-2 flex items-center mt-4">

            <div className="text-green">
                <GiftIcon/>
            </div>

            <div className="ml-4 flex-1">
                <p>
                    Your cart is eligible
                    for <b>{ numberOfFreePlugins } free { plural('plugin', numberOfFreePlugins) }</b>. An email to
                    select { numberOfFreePlugins === 1 ? 'it' : 'them' } will be sent after checkout.<br/>
                    <a href={ cartData.efstcurl } title="" className="inapp-hidden text-xs text-gray-500 font-bold">Terms & conditions apply.</a>
                </p>
            </div>
        </div>
    )
};

export  default FreePluginBox;